// ReviewModal.js
import React, { useState } from 'react';
import styled from 'styled-components';
import { FaStar } from 'react-icons/fa';

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const ModalContent = styled.div`
  background: #fff;
  padding: 30px;
  border-radius: 10px;
  width: 90%;
  max-width: 500px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
  position: relative;
`;

const CloseButton = styled.button`
  position: absolute;
  top: 15px;
  right: 15px;
  background: transparent;
  border: none;
  font-size: 1.5em;
  cursor: pointer;
  color: #555;
  &:hover {
    color: #333;
  }
`;

const ModalTitle = styled.h3`
  margin-top: 0;
  margin-bottom: 20px;
  color: #333;
  text-align: center;
`;

const StarRating = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 20px;

  svg {
    cursor: pointer;
    font-size: 2em;
    color: #ccc;
    transition: color 0.2s;

    &.active {
      color: #ffd700; /* Gold color for active stars */
    }
    &:hover {
        color: #ffeb3b; /* Lighter gold on hover */
    }
  }
`;

const ReviewForm = styled.form`
  display: flex;
  flex-direction: column;
`;

const TextArea = styled.textarea`
  width: 100%;
  padding: 10px;
  margin-bottom: 15px;
  border: 1px solid #ddd;
  border-radius: 5px;
  min-height: 100px;
  font-size: 1em;
  resize: vertical;
`;

const SubmitButton = styled.button`
  background-color: #e67e22;
  color: #fff;
  border: none;
  padding: 12px 20px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 1.1em;
  font-weight: bold;
  transition: background-color 0.3s ease;
  &:hover {
    background-color: #d35400;
  }
  &:disabled {
    background-color: #cccccc;
    cursor: not-allowed;
  }
`;

const ReviewModal = ({ onClose, onSubmit, productName }) => {
  const [rating, setRating] = useState(0);
  const [comment, setComment] = useState('');
  const [hover, setHover] = useState(0); // For hover effect on stars

  const handleSubmit = (e) => {
    e.preventDefault();
    if (rating === 0) {
      alert('অনুগ্রহ করে একটি রেটিং নির্বাচন করুন।');
      return;
    }
    onSubmit(rating, comment);
  };

  return (
    <ModalOverlay>
      <ModalContent>
        <CloseButton onClick={onClose}>&times;</CloseButton>
        <ModalTitle>{productName} এর জন্য রিভিউ দিন</ModalTitle>
        <ReviewForm onSubmit={handleSubmit}>
          <StarRating>
            {[...Array(5)].map((star, index) => {
              const currentRating = index + 1;
              return (
                <label key={index}>
                  <input
                    type="radio"
                    name="rating"
                    value={currentRating}
                    onClick={() => setRating(currentRating)}
                    style={{ display: 'none' }} 
                  />
                  <FaStar
                    className={currentRating <= (hover || rating) ? 'active' : ''}
                    onMouseEnter={() => setHover(currentRating)}
                    onMouseLeave={() => setHover(0)}
                  />
                </label>
              );
            })}
          </StarRating>
          <TextArea
            placeholder="আপনার মতামত লিখুন..."
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            rows="5"
          />
          <SubmitButton type="submit" disabled={rating === 0}>
            রিভিউ জমা দিন
          </SubmitButton>
        </ReviewForm>
      </ModalContent>
    </ModalOverlay>
  );
};

export default ReviewModal;